import React from "react";
import PropTypes from "prop-types";
import CreatableSelect from "react-select/creatable";

const creatableStyle = {
  control: (provided, state) => ({
    ...provided,
    border: 0,
    minHeight: "44px",
    borderColor: state.isFocused ? "#023A66" : provided.borderColor,
    "&:hover": { borderColor: "#023A66 !important" },
    boxShadow: "none",
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    backgroundColor: isDisabled ? null : isSelected ? "#023A66" : isFocused ? "#F3F5F7" : null,
    color: isDisabled ? "#ccc" : isSelected ? "white" : "#1D1B22",
    cursor: isDisabled ? "not-allowed" : "default",
    "&:active": { backgroundColor: "#F3F5F7" },
  }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
  menuList: (provided) => ({ ...provided, zIndex: 10 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#F3F5F7",
    borderRadius: "4px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#023A66",
    fontSize: "14px",
    fontFamily: "urwgeometric-medium",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#023A66",
    ":hover": {
      backgroundColor: "#F3F5F7",
      color: "#023A66",
    },
  }),
};

function CreatableMultiSelectComponent({
  label = "",
  isRequired = false,
  errorMessage = "",
  name = "",
  register = () => {},
  registerArgs = {},
  containerClassName = "",
  labelClassName = "",
  isDisabled = false,
  options = [],
  onChange = () => {},
  value = null,
  placeholder = "Select or type to add...",
}) {
  return (
    <div
      className={
        containerClassName ? containerClassName : "flex flex-col gap-[10px]"
      }
    >
      {label && (
        <div
          className={
            labelClassName
              ? labelClassName
              : "text-primary font-semibold text-[16px]"
          }
        >
          {label} {isRequired && <span className="text-red">*</span>}
        </div>
      )}
      <div
        className={`grid w-full ${
          errorMessage &&
          isRequired &&
          (!value || (Array.isArray(value) && value.length <= 0))
            ? "border-red"
            : "border-default-color"
        } border-solid border-[1px] rounded-[4px]`}
      >
        <CreatableSelect
          name={name}
          {...register(name, { ...registerArgs })}
          isMulti
          isClearable
          closeMenuOnSelect={false}
          blurInputOnSelect={false}
          value={value}
          placeholder={placeholder}
          isDisabled={isDisabled}
          options={options}
          onChange={(selected) => {
            if (typeof onChange === "function") {
              onChange(selected || []);
            }
          }}
          formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
          styles={creatableStyle}
          menuPortalTarget={document.body}
        />
      </div>
      {errorMessage &&
        isRequired &&
        (!value || (Array.isArray(value) && value.length <= 0)) && (
          <span className="text-[12px] text-red font-regular">
            {errorMessage}
          </span>
        )}
    </div>
  );
}

CreatableMultiSelectComponent.propTypes = {
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
  register: PropTypes.func,
  registerArgs: PropTypes.object,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  isDisabled: PropTypes.bool,
  options: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.any,
  placeholder: PropTypes.string,
};

export default CreatableMultiSelectComponent;
